var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/trending-up.581b1ea3.png","uri@3x": __webpack_public_path__ + "static/media/trending-up.5081e269.png","uri@2x": __webpack_public_path__ + "static/media/trending-up.0de83480.png",
    width: 24,
    height: 14
});